import classNames from 'classnames'
import React from 'react'
import styled from 'styled-components'
import * as css from './JumpToStrip.css'

interface ILetterStripProps {
  height: number
  dataWidth: number
  stripData: Array<string>
  dataToHighlight: string
  onDataSelect: any
  isNewLayout?: boolean
}

const StyledDiv = styled.div<{ height: number }>`
  height: ${props => props.height + 'px'};
`

const StyledSpan = styled.span<{ width: number }>`
  width: ${props => props.width + 'px'};
`

export const JumpToStrip: React.FunctionComponent<ILetterStripProps> = ({
  stripData,
  dataToHighlight,
  onDataSelect,
  height,
  dataWidth
}) => {
  return (
    <StyledDiv height={height} className={css.LetterContainer}>
      {stripData.length &&
        stripData.map(letter => (
          <StyledSpan
            key={letter}
            width={dataWidth}
            id={letter}
            className={classNames({
              [css.letter]: true,
              [css.highlight]: letter === dataToHighlight
            })}
            onClick={onDataSelect}
          >
            {letter}
          </StyledSpan>
        ))}
    </StyledDiv>
  )
}
